import { z } from 'zod';
import { idSchema, iso8601Schema } from './common';
import { invoiceBillingFrequencySchema, invoiceLineItemSchema, invoiceScopeSnapshotSchema, invoiceStatusSchema } from './invoice';

export const manualInvoiceTemplateSchema = z.object({
  lineItems: z.array(invoiceLineItemSchema).min(1).max(100),
  notes: z.string().max(2000).nullable(),
  scopeSnapshot: invoiceScopeSnapshotSchema.nullable(),
}).strip();
export const updateManualInvoiceTemplateSchema = z.object({
  brandingProfileId: idSchema.nullable().optional(),
  lineItems: z.array(invoiceLineItemSchema).min(1).max(100),
  notes: z.string().max(2000).nullable(),
}).strict();
export const manualInvoiceScheduleOutputSchema = z.object({
  id: idSchema,
  clientId: idSchema,
  brandingProfileId: idSchema.nullable().optional(),
  ownerId: idSchema.nullable(),
  frequency: invoiceBillingFrequencySchema,
  startDate: iso8601Schema,
  nextInvoiceDate: iso8601Schema,
  dueOffsetDays: z.number().int().nonnegative(),
  paused: z.boolean(),
  template: manualInvoiceTemplateSchema,
  createdAt: iso8601Schema,
  updatedAt: iso8601Schema,
  invoices: z.array(z.object({
    id: idSchema, invoiceNumber: z.string(), status: invoiceStatusSchema,
    deletedAt: iso8601Schema.nullable(), recurringPeriodStart: iso8601Schema.nullable(),
  })),
});
export type ManualInvoiceScheduleOutput = z.infer<typeof manualInvoiceScheduleOutputSchema>;
export type UpdateManualInvoiceTemplateInput = z.infer<typeof updateManualInvoiceTemplateSchema>;
